export function getUrlSegmentsFromString(url: string) {
    return url
        .split('?')[0]
        .split('/')
        .filter((urlSegment) => urlSegment !== '');
}
